export function sum(total: number, num: number) {
    return total + num;
}

export function setValueByPath(obj: any, path: string, value: any) {
    const pathStack = path.split('.');

    while (pathStack.length > 1) {
        obj = obj[pathStack.shift() as string];
    }

    obj[pathStack.shift() as string] = value;
}
